// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"61b26eef","239":"e39fb35b"}[chunkId] + ".chunk.js";
};